export const lighterColor = (color: `#${string}` | `rgb(${number}, ${number}, ${number})`, percent: number) => {
  if (percent < 0) {
    throw new Error('Percent must be a positive number');
  }

  const num = parseInt(color.slice(1), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) + amt;
  const G = ((num >> 8) & 0x00ff) + amt;
  const B = (num & 0x0000ff) + amt;
  const newColor = `#${(0x1000000 + (Math.min(255, R) << 16) + (Math.min(255, G) << 8) + Math.min(255, B)).toString(16).slice(1)}`;
  return newColor;
};

export const darkerColor = (color: `#${string}` | `rgb(${number}, ${number}, ${number})`, percent: number) => {
  if (percent < 0) {
    throw new Error('Percent must be a positive number');
  }

  const num = parseInt(color.slice(1), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) - amt;
  const G = ((num >> 8) & 0x00ff) - amt;
  const B = (num & 0x0000ff) - amt;
  const newColor = `#${(0x1000000 + (Math.max(0, R) << 16) + (Math.max(0, G) << 8) + Math.max(0, B)).toString(16).slice(1)}`;
  return newColor;
};

export const convertHexToRGB = (hex: string) => {
  let hexColor = hex.replace('#', '');
  let r,
    g,
    b,
    a = 1;

  if (hexColor.length === 3) {
    hexColor = hexColor[0] + hexColor[0] + hexColor[1] + hexColor[1] + hexColor[2] + hexColor[2];
  }

  if (hexColor.length === 6) {
    r = parseInt(hexColor.substring(0, 2), 16);
    g = parseInt(hexColor.substring(2, 4), 16);
    b = parseInt(hexColor.substring(4, 6), 16);
  } else if (hexColor.length === 8) {
    r = parseInt(hexColor.substring(0, 2), 16);
    g = parseInt(hexColor.substring(2, 4), 16);
    b = parseInt(hexColor.substring(4, 6), 16);
    a = parseInt(hexColor.substring(6, 8), 16) / 255;
  }

  return a < 1 ? `rgba(${r}, ${g}, ${b}, ${a})` : `rgb(${r}, ${g}, ${b})`;
};

export const convertRGBToHex = (rgb: string) => {
  if (!rgb.startsWith('rgba') && !rgb.startsWith('rgb')) {
    throw new Error('Invalid input');
  }

  const colorValues = rgb
    .replace('rgba(', '')
    .replace('rgb(', '')
    .replace(')', '')
    .split(', ')
    .map((color) => (color.includes('.') ? parseFloat(color) : parseInt(color, 10)));

  if (rgb.startsWith('rgba(') && colorValues.length !== 4) {
    throw new Error('Invalid input');
  }

  if (rgb.startsWith('rgb(') && colorValues.length !== 3) {
    throw new Error('Invalid input');
  }

  const [r, g, b, a = 1] = colorValues;

  const hex = `#${Math.round(r).toString(16).padStart(2, '0')}${Math.round(g).toString(16).padStart(2, '0')}${Math.round(b)
    .toString(16)
    .padStart(2, '0')}${Math.round(a * 255)
    .toString(16)
    .padStart(2, '0')}`;

  return hex;
};
